import { createSelector } from 'reselect';
import { getState } from './state';

export const getActivitySlice = createSelector([getState], slice => {
  return slice.activity;
});

export const getActivityRoomQueue = createSelector(getActivitySlice, state => {
  return state?.roomsQueue;
});

export const getCounterSlice = createSelector([getState], slice => {
  return slice.counter;
});

export const getCounterConversations = createSelector(
  getCounterSlice,
  state => {
    return state?.conversations;
  }
);

export const getCounterRequests = createSelector(getCounterSlice, state => {
  return state?.requests;
});
